<div>{{ 'authentication.loginCallback.processingLogin' | localize }}</div>
